"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-sticky-flag.tsx
var StickyFlag = function StickyFlag(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M14 0H0V18L7 15L14 18V0Z"
  }));
};

var _default = StickyFlag;
exports.default = _default;